import { useState, useEffect } from "react";
import { useLogging } from "src/v1/features/PreData/hooks/useLogging";
import { pathMapper } from "../v1/features/Landing/helpers/pathMapper";
import { useKakaoModal } from "src/hooks/useKakaoModal";
import { IcKakaoTalk } from "../v1/features/Landing/icons/IcKakaoTalk";
import { useTossPixelLead } from "src/hooks/useAds";

export const BottomRightLink = () => {
  const { onClickHandler } = useKakaoModal();
  const { logEvent } = useLogging();
  const currentUrl = window.location.href;
  const path = pathMapper(currentUrl);
  const trackLead = useTossPixelLead();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Hide the component if pathname includes /chatlist
  if (
    window.location.pathname.includes("/chatlist") ||
    window.location.host.startsWith("sm.") ||
    window.location.pathname.includes("infoTelling")
  ) {
    return null;
  }

  const onKakaoClickHandler = () => {
    logEvent({
      name: "Kakao",
      value: "To Kakao Chat",
      type: "Kakao",
      from: path,
    });
    trackLead("Consultation");

    onClickHandler();
  };

  return (
    <div
      className={`fixed bottom-10 right-5 z-10 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        onClick={onKakaoClickHandler}
        id="kakao_click"
        className="cursor-pointer flex items-center gap-1.5 px-3 py-2.5 text-black font-semibold rounded-full bg-[#F6BE28] hover:bg-[#F5C947] transition-colors duration-200"
      >
        <IcKakaoTalk />
        카톡 상담
      </div>
    </div>
  );
};
